// Volume-Bundle Quickpick
// Klick auf Tier-Kachel -> setzt nur die Menge im Quantity-Input der Produktseite.
// Kein /cart/add.js mehr -- der Haupt-Kaufbutton bleibt einziger ATC-Auslöser.
// Reverse-Sync: manuelle Aenderungen am Quantity-Input markieren die passende Kachel.

class VolumeBundle extends HTMLElement {
  connectedCallback() {
    this.tiers = Array.from(this.querySelectorAll('[data-set-quantity]'));
    this.qtyInput =
      document.querySelector('product-info input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');

    if (!this.qtyInput || this.tiers.length === 0) return;

    this.tiers.forEach((tier) => {
      tier.addEventListener('click', () => this.selectTier(tier));
    });

    this.qtyInput.addEventListener('input', () => this.syncFromInput());
    this.qtyInput.addEventListener('change', () => this.syncFromInput());

    this.syncFromInput();
  }

  selectTier(tier) {
    const qty = parseInt(tier.dataset.setQuantity, 10);
    if (!qty) return;
    this.qtyInput.value = qty;
    this.qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    this.markSelected(tier);
  }

  syncFromInput() {
    const current = parseInt(this.qtyInput.value, 10);
    const matched = this.tiers.find(
      (t) => parseInt(t.dataset.setQuantity, 10) === current
    );
    this.markSelected(matched || null);
  }

  markSelected(tier) {
    this.tiers.forEach((t) => {
      const on = t === tier;
      t.classList.toggle('is-selected', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
}

if (!customElements.get('volume-bundle')) {
  customElements.define('volume-bundle', VolumeBundle);
}
